import {customButtonStyles} from "./styles/custom-button-styles";
import {customPluginAttrPrefix, customPluginNameAttr} from "@/components/tinyMce/plugins/tinyMceCustomPluginsConstants";

const t: any = {
  "fr": {
    "toolbarTooltip": "Insérer/Modifier un bouton",
    "dialog": {
      "title": "Insérer/Modifier un bouton",
      "btnDetail": {
        "label": "Libellé du bouton",
        "url": "URL",
        "hoverTitle": "Titre au survol",
        "openMode": {
          "title": "Ouvrir le lien dans...",
          "currentTab": 'Fenêtre active',
          'newTab': 'Nouvelle fenêtre',
        }
      },
      'actions': {
        "ok": "Enregistrer",
        "cancel": "Annuler"
      },
    }
  },
  "en": {
    "toolbarTooltip": 'Insert/Edit Button',
    "dialog": {
      'title': 'Insert/Edit Button',
      'btnDetail': {
        'label': 'Button label',
        'url': 'URL',
        'hoverTitle': 'Title while hovering',
        "openMode": {
          "title": "Open link in...",
          "currentTab": "Current window",
          "newTab": "New window"
        }
      },
      'actions': {
        'ok': 'Save',
        'cancel': 'Cancel',
      }
    }
  },
  "de": {
    "toolbarTooltip": "Schaltfläche einfügen/bearbeiten",
    "dialog": {
      "title": "Schaltfläche einfügen/bearbeiten",
      "btnDetail": {
        "label": "Beschriftung der Schaltfläche",
        "url": "URL",
        "hoverTitle": "Titel beim Hover",
        "openMode": {
          "title": "Link öffnen in...",
          "currentTab": "Aktivem Fenster",
          "newTab": "Neuem Fenster"
        }
      },
      'actions': {
        "ok": "Speichern",
        "cancel": "Abbrechen"
      }
    }
  },
  "es": {
    "toolbarTooltip": "Insertar/Editar botón",
    "dialog": {
      "title": "Insertar/Editar botón",
      "btnDetail": {
        "label": "Etiqueta del botón",
        "url": "URL",
        "hoverTitle": "Título al pasar el cursor",
        "openMode": {
          "title": "Abrir el enlace en...",
          "currentTab": "Ventana activa",
          "newTab": "Nueva ventana"
        }
      },
      'actions': {
        "ok": "Guardar",
        "cancel": "Cancelar"
      }
    }
  }
}

const customButtonToolbarIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M11.5,11L17.88,16.37L17,16.55L16.36,16.67C15.73,16.8 15.37,17.5 15.65,18.07L15.92,18.65L17.28,21.59L15.86,22.25L14.5,19.32L14.24,18.74C13.97,18.15 13.22,17.97 12.72,18.38L12.21,18.78L11.5,
              19.35V11M10.76,8.69A0.76,0.76 0 0,0 10,9.45V20.9C10,21.32 10.34,21.66 10.76,21.66C10.95,21.66 11.11,21.6 11.24,21.5L13.15,19.95L14.81,23.57C14.94,23.84 15.21,24 15.5,24C15.61,24 15.72,24 15.83,
              23.92L18.59,22.64C18.97,22.46 19.15,22 18.95,21.63L17.28,18L19.69,17.55C19.85,17.5 20,17.43 20.12,17.29C20.39,16.97 20.35,16.5 20,16.21L11.26,8.86L11.25,8.87C11.12,8.76 10.95,8.69 10.76,8.69M15,
              10V8H20V10H15M13.83,4.76L16.66,1.93L18.07,3.34L15.24,6.17L13.83,4.76M10,0H12V5H10V0M3.93,14.66L6.76,11.83L8.17,13.24L5.34,16.07L3.93,14.66M3.93,3.34L5.34,1.93L8.17,4.76L6.76,6.17L3.93,3.34M7,10H2V8H7V10"/>
      </svg>
    `;

export const customButtonPluginName = 'custombutton';

export const useCustomButton = (editor: any) => {
  const lang = editor.getParam('custombutton_i18n_locale', 'en').toLowerCase();
  const customBtnAttribute = `${customPluginAttrPrefix}-${customButtonPluginName}`;
  const customBtnClass = 'tmce-plugin-custom-button';
  const customBtnColor = editor.getParam('custombutton_button_color', '#555555');

  editor.ui.registry.addIcon('custombutton-icon', customButtonToolbarIcon);

  editor.ui.registry.addButton(customButtonPluginName, {
    icon: 'custombutton-icon',
    tooltip: t[lang].toolbarTooltip,
    onAction: () => {
      openButtonModal();
    },
  });

  editor.on('preinit', () => {
    injectStyleSheet(editor);
  });

  editor.on('init', () => {
    editor.on('click', (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'A' && target.hasAttribute(customBtnAttribute)) {
        e.preventDefault();
        openButtonModal(target);
      }
    });
  });

  const openButtonModal = (existingButton?: HTMLElement) => {
    const isEditing = !!existingButton;

    // Récupérer les valeurs existantes
    const currentLabel = existingButton?.textContent?.trim() || '';
    const currentUrl = existingButton?.getAttribute('href') || '';
    const currentTitle = existingButton?.getAttribute('title') || '';
    const currentTarget = existingButton?.getAttribute('target') === '_blank' ? 'new' : 'current';

    editor.windowManager.open({
      title: t[lang].dialog.title,
      body: {
        type: 'panel',
        items: [
          {
            type: 'input',
            name: 'url',
            label: t[lang].dialog.btnDetail.url,
          },
          {
            type: 'input',
            name: 'label',
            label: t[lang].dialog.btnDetail.label,
          },
          {
            type: 'input',
            name: 'title',
            label: t[lang].dialog.btnDetail.hoverTitle,
          },
          {
            type: 'selectbox',
            name: 'target',
            label: t[lang].dialog.btnDetail.openMode.title,
            items: [
              { value: 'new', text: t[lang].dialog.btnDetail.openMode.newTab },
              { value: 'current', text: t[lang].dialog.btnDetail.openMode.currentTab }
            ],
          }
        ]
      },
      initialData: {
        label: currentLabel,
        url: currentUrl,
        title: currentTitle,
        target: currentTarget
      },
      buttons: [
        {
          type: 'cancel',
          text: t[lang].dialog.actions.cancel
        },
        {
          type: 'submit',
          text: t[lang].dialog.actions.ok,
          primary: true
        }
      ],
      onSubmit: (api: any) => {
        const data = api.getData();

        if (!data.label?.trim() || !data.url?.trim()) {
          return;
        }

        const label = data.label.trim();
        const url = data.url.trim();
        const title = data.title?.trim() || '';
        const targetAttr = data.target === 'new'
            ? 'target="_blank" rel="noopener noreferrer"'
            : '';

        const titleData = title ? `title="${title}"` : '';
        const buttonHtml = `<a ${customPluginNameAttr}="${customButtonPluginName}" href="${url}" ${titleData} ${targetAttr} ${customBtnAttribute}="true" contenteditable="false"
                                            class="${customBtnClass} ${customBtnClass}--primary" style="background-color: ${customBtnColor}; color: white !important;">
                                        ${label}
                                   </a>`;
        const tempDiv = document.createElement('div');
        if (isEditing && existingButton) {
          // Mode édition : remplacer le bouton
          tempDiv.innerHTML = buttonHtml;
          const newButton = tempDiv.firstChild as HTMLElement;
          existingButton.replaceWith(newButton);
        } else {
          // Mode insertion : ajouter le bouton + focus après
          tempDiv.innerHTML = `&nbsp;${buttonHtml}&nbsp;`;
          const fragment = document.createDocumentFragment();
          while (tempDiv.firstChild) {
            fragment.appendChild(tempDiv.firstChild);
          }
          editor.selection.getRng().insertNode(fragment);

          // Placer le focus juste après le bouton
          setTimeout(() => {
            const buttons = editor.getBody().querySelectorAll(`[${customBtnAttribute}]`);
            const lastButton = buttons[buttons.length - 1];
            if (lastButton?.nextSibling) {
              const range = editor.dom.createRng();
              range.setStart(lastButton.nextSibling, 1);
              range.setEnd(lastButton.nextSibling, 1);
              editor.selection.setRng(range);
              editor.focus();
            }
          }, 50);
        }

        api.close();
      }
    });
  };
};

function injectStyleSheet(editor: any): void {
  const style = editor.getDoc().createElement('style');
  style.textContent = `${customButtonStyles}`;
  editor.getDoc().head.appendChild(style);
}
